var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D9E9E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6673 13.3867V14.0001C20.6665 15.4377 20.201 16.8365 19.3402 17.988C18.4794 19.1394 17.2695 19.9817 15.8909 20.3893C14.5123 20.797 13.0388 20.748 11.6903 20.2498C10.3418 19.7516 9.19042 18.8308 8.40796 17.6248C7.6255 16.4188 7.25385 14.9921 7.34844 13.5576C7.44303 12.1231 7.99879 10.7576 8.93284 9.66479C9.86689 8.57195 11.1292 7.81033 12.5314 7.4935C13.9337 7.17668 15.4008 7.32163 16.714 7.90674M20.6673 8.66674L14.0007 15.3401L12.0007 13.3401",
    stroke: "#43936C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_1710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a5fac09d0e77c721539f2bcdb969ce47.svg";
export { ForwardRef as ReactComponent };